export interface FieldValueChangeOutput {
  updatedData: any;
  columnData: any;
}
